import { Node, mergeAttributes, wrappingInputRule } from '@tiptap/core';
var inputRegex = /^\s*>\s$/;
var Blockquote = Node.create({
  name: 'blockquote',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: 'block+',
  group: 'block',
  defining: true,
  parseHTML: function parseHTML() {
    return [{
      tag: 'blockquote'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['blockquote', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setBlockquote: function setBlockquote() {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.wrapIn(_this.name);
        };
      },
      toggleBlockquote: function toggleBlockquote() {
        return function (_ref3) {
          var commands = _ref3.commands;
          return commands.toggleWrap(_this.name);
        };
      },
      unsetBlockquote: function unsetBlockquote() {
        return function (_ref4) {
          var commands = _ref4.commands;
          return commands.lift(_this.name);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    return {
      'Mod-Shift-b': function ModShiftB() {
        return _this2.editor.commands.toggleBlockquote();
      }
    };
  },
  addInputRules: function addInputRules() {
    return [wrappingInputRule({
      find: inputRegex,
      type: this.type
    })];
  }
});
export { Blockquote, Blockquote as default, inputRegex };